import React from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import {
  resolveTo,
  initFormValues,
} from '~/commons/helpers';

import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';

const FormResource = ({
  stored,
  schema,
  defaults,
  api,
  children,
  options,
  onSubmit = (v) => v,
  formStatus = {},
}) => {
  const history = useHistory();
  const [res, req] = useHttpStatus({
    onSuccess({ data }) {
      if (!stored) {
        history.push(resolveTo(`../${data[0]._id}`));
      }
    },
  });

  return (
    <Formik
      validationSchema={schema}
      initialStatus={formStatus}
      initialValues={initFormValues(defaults, stored, options)}
      onSubmit={async (values, actions) => {
        const { status } = await req({
          method: stored ? 'patch' : 'post',
          url: `${api}${stored ? `/${stored._id}` : ''}`,
          data: onSubmit(values),
        });

        if (status === 'success') {
          actions.setSubmitting(false);
          actions.resetForm({ values });
        }
      }}>
      {(props) => (
        <Form>
          <FormHttpSaveBtn
            res={res}
            className="btn-primary mb-3"
          />
          <FormHttpAlert res={res} />
          {typeof children === 'function'
            ? children(props)
            : children}
        </Form>
      )}
    </Formik>
  );
};

export default FormResource;
